<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height">
          <v-col
              cols="12"
              md="6"
              class="dct-auth__brand d-none d-md-flex flex-column justify-space-between pa-12 white--text"
          >
            <div class="d-flex align-center">
              <div class="dct-logo dct-logo--onbrand">DCT</div>
              <span class="ml-3 font-weight-bold" style="font-size: 16px">
                Domain Collector
              </span>
            </div>
            <div style="max-width: 380px">
              <h1
                  class="font-weight-bold mb-4"
                  style="font-size: 28px; line-height: 1.3"
              >
                One tool for every domain-research parameter.
              </h1>
              <p
                  class="mb-0"
                  style="color: rgba(255, 255, 255, 0.82); font-size: 14px; line-height: 1.6"
              >
                Create an account to queue collection tasks, track their
                progress and pull the results into your exports.
              </p>
            </div>
            <div style="color: rgba(255, 255, 255, 0.6); font-size: 12px">
              Access is granted per team.
            </div>
          </v-col>

          <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-center pa-6"
          >
            <div style="width: 100%; max-width: 360px">
              <h2 class="font-weight-bold mb-1" style="font-size: 22px">
                Create account
              </h2>
              <p class="mb-6" style="opacity: 0.6; font-size: 13px">
                It takes a minute.
              </p>

              <v-form ref="form" v-model="valid">
                <div class="text-body-2 font-weight-medium mb-1">Name</div>
                <v-text-field
                    outlined
                    dense
                    :rules="nameRules"
                    v-model="name"
                    hide-details="auto"
                    class="mb-4"
                ></v-text-field>

                <div class="text-body-2 font-weight-medium mb-1">Email</div>
                <v-text-field
                    outlined
                    dense
                    :rules="emailRules"
                    v-model="email"
                    prepend-inner-icon="mdi-email-outline"
                    hide-details="auto"
                    class="mb-4"
                ></v-text-field>

                <div class="text-body-2 font-weight-medium mb-1">Password</div>
                <v-text-field
                    outlined
                    dense
                    :append-icon="show3 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                    :type="show3 ? 'text' : 'password'"
                    :rules="passwordRules"
                    name="input-10-2"
                    v-model="password"
                    prepend-inner-icon="mdi-lock-outline"
                    hint="At least 8 characters"
                    persistent-hint
                    @click:append="show3 = !show3"
                ></v-text-field>
              </v-form>

              <v-alert
                  text
                  dense
                  dismissible
                  border="left"
                  type="error"
                  v-if="error_message"
                  class="mt-4 mb-0"
              >
                <span v-html="error_message"></span>
              </v-alert>

              <v-btn
                  color="primary"
                  block
                  large
                  elevation="0"
                  class="mt-6"
                  @click="register"
                  :loading="loading"
              >
                Create account
              </v-btn>

              <p class="text-center mt-6 mb-0" style="opacity: 0.7; font-size: 13px">
                Already have an account?
                <a href="#" @click.prevent="to_login">Sign in</a>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Index",
  props: {
    source: String,
  },
  data() {
    return {
      error_message: undefined,
      snackbar: false,
      valid: false,
      show3: false,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be less than 8 characters',
      ],
      confirm_password: ''
    }
  },
  computed: {
    message() {
      return this.$store.state.auth.response_register.msg
    },
    loading: {
      set(value) {
        this.$store.state.auth.loading = value
      },
      get() {
        return this.$store.state.auth.loading
      }
    }
  },
  methods: {
    to_login() {
      this.$router.push('/login')
    },
    register() {
      let self = this;

      self.error_message = undefined

      if (false === this.$refs.form.validate()) {
        return;
      }

      self.loading = true;

      self.$store.dispatch('register', {
        name: self.name,
        email: self.email,
        password: self.password,
        then() {
          self.$store.dispatch('login', {
            email: self.email,
            password: self.password,
            then() {
              let redirect_url = self.$store.state.redirect_to_after_login;

              if (redirect_url !== '') {
                self.$store.state.redirect_to_after_login = '';
                self.$router.push(redirect_url)
              } else {
                self.$router.push('/')
              }
              self.loading = false;
            },
            catch() {
              self.loading = false;
            }
          })
        },
        catch() {
          self.error_message = self.$store.state.auth.response_register.msg
          if (self.error_message === "Duplicate email"){
            self.error_message = "Duplicate email, please contact <a href='mailto:'>vitaliy.klih@boosta.co</a>"
          }
          self.snackbar = true;
          self.loading = false;
        }
      })
    }
  },
}
</script>